/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ref_TitleInputs */

const en_minifier_ref_title = /** @type {(inputs: Minifier_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measured sizes for a 40 record array`)
};

const ko_minifier_ref_title = /** @type {(inputs: Minifier_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40개 레코드 배열의 실측 크기`)
};

const ja_minifier_ref_title = /** @type {(inputs: Minifier_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40 件レコード配列の実測サイズ`)
};

/**
* | output |
* | --- |
* | "Measured sizes for a 40 record array" |
*
* @param {Minifier_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ref_title = /** @type {((inputs?: Minifier_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ref_title(inputs)
	if (locale === "ko") return ko_minifier_ref_title(inputs)
	return ja_minifier_ref_title(inputs)
});